import React, { Component } from 'react'
import PreInternal from '../build/images/monitoria.png'
import ChatSimultComponent from '../containers/ChatSimult'

export default class MonitoringClear extends Component {

render(){   
    return( 
       <div id="column2" className="chat-page column split column-chat">
          <div className="center">
            <div className="center__item">
              <img src={PreInternal} />
            </div>
          </div>
          <div className="block transparent active-chats" id="active-chats">
            <div className="active-chats__tabs">
                <ul className="active-chats__list">
                  <ChatSimultComponent remotescreen={'monitorias'}/>
                </ul>
              </div>
            </div>
       </div>
    )}               
}

